import React from "react";
import { Button } from "../Shared/Button/";
import "../Pagination/style.css";

const Pagination = ({
  pageNumber,
  totalPages,
  perPage,
  setLoading,
  handlePageChange,
  handlePerPageChange,
}) => {
  return (
    <div className="pagination">
      <Button
        className={`back ${pageNumber === 1 ? "disabled" : ""}`}
        onClick={() => {
          setLoading(true);
          handlePageChange(pageNumber, "back");
        }}
        label="Previous"
        disabled={pageNumber === 1}
      />

      <div className="pageNo_">
        {pageNumber} of {totalPages}
      </div>
      <div className="per-page">
        Show{" "}
        <select value={perPage} onChange={handlePerPageChange}>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
        </select>{" "}
        Items per page
      </div>

      <Button
        className={`back ${pageNumber === totalPages ? "disabled" : ""}`}
        onClick={() => {
          setLoading(true);
          handlePageChange(pageNumber, "next");
        }}
        label="Next"
        disabled={pageNumber === totalPages}
      />
    </div>
  );
};

export default Pagination;
